import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SubmitButton from 'forms/shared/buttons/submit'
import authActions from 'actions/auth/actions'
import ChangePasswordForm from './form'

// @TODO: A bug => click save on profile => click change password => modal won't appear(according to rdt it is destroyed upon click)
const ChangePassword = ({ changePassword, hideModal, notification: { type } }) => {
  const formName = 'change-password-form'

  return (
    <div className="change-password-form bg-white flex flex-col">
      {type === 'success' && hideModal()}
      <ChangePasswordForm form={formName} hideModal={hideModal} onSubmit={(values) => changePassword(values)} />
      <SubmitButton
        className="px-4 py-2 mt-3 m-auto rounded-lg bg-orange-400 hover:bg-orange-300 text-white"
        formName={formName}
      >
        CHANGE PASSWORD
      </SubmitButton>
    </div>
  )
}

ChangePassword.propTypes = {
  changePassword: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  notification: PropTypes.object,
}

const mapStateToProps = ({ notification }) => ({
  notification,
})

const mapDispatchToProps = {
  changePassword: authActions.changePassword,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePassword)
